import { FULL_HD, HD } from '@bedrock-rdk/constants';

export const GAP = {
  [HD]: 16,
  [FULL_HD]: 16,
};

export const MIN_BUTTON_WIDTH = {
  [HD]: 175,
  [FULL_HD]: 175,
};
